import { render, staticRenderFns } from "./TeachingPaperForm.vue?vue&type=template&id=59dbf3f2&scoped=true"
import script from "./TeachingPaperForm.vue?vue&type=script&lang=js"
export * from "./TeachingPaperForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dbf3f2",
  null
  
)

export default component.exports